import { render, staticRenderFns } from "./leftmenu.vue?vue&type=template&id=9c0d1de8&scoped=true"
import script from "./leftmenu.vue?vue&type=script&lang=js"
export * from "./leftmenu.vue?vue&type=script&lang=js"
import style0 from "./leftmenu.vue?vue&type=style&index=0&id=9c0d1de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0d1de8",
  null
  
)

export default component.exports